// extracted by mini-css-extract-plugin
export default {"lock":"SettingsLock_lock__3wM1z","tooltip_content":"SettingsLock_tooltip_content__1r0dk","tooltip":"SettingsLock_tooltip__yFxkn","tooltip_text":"SettingsLock_tooltip_text__VTp-E"};